import { useEffect, useState } from 'react';
import { Timer } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import styles from './SessionIdleBadge.module.css';

function formatRemaining(ms) {
  const totalSec = Math.max(0, Math.ceil(ms / 1000));
  const mins = Math.floor(totalSec / 60);
  const secs = totalSec % 60;
  return `${mins}:${String(secs).padStart(2, '0')}`;
}

export default function SessionIdleBadge() {
  const { subscribeIdleExpires } = useAuth();
  const [idleExpiresAt, setIdleExpiresAt] = useState(null);
  const [remainingMs, setRemainingMs] = useState(null);

  useEffect(() => subscribeIdleExpires(setIdleExpiresAt), [subscribeIdleExpires]);

  useEffect(() => {
    if (!idleExpiresAt) {
      setRemainingMs(null);
      return undefined;
    }

    const tick = () => setRemainingMs(Math.max(0, idleExpiresAt - Date.now()));
    tick();
    const id = setInterval(tick, 250);
    return () => clearInterval(id);
  }, [idleExpiresAt]);

  if (remainingMs == null) return null;

  const warn = remainingMs <= 2 * 60 * 1000;

  return (
    <div
      className={`${styles.badge} ${warn ? styles.warn : ''}`}
      title="Ops counters lock after 15 minutes with no activity. Your screen and anything you typed come back when you sign in again."
    >
      <Timer size={13} strokeWidth={2.25} />
      <span className={styles.label}>Inactive in</span>
      <span className={styles.time}>{formatRemaining(remainingMs)}</span>
    </div>
  );
}
